'format es6';
'use strict';

import Cart from './Shop.cart';
import Checkout from './Shop.checkout';


//Dans les autres pages, setup les messages d'erreur/update qui peuvent être présents dans le html
import Prompts from '../utils/Prompts';
Prompts.setupGlobalPrompts();